import React, { ReactElement } from 'react'
import styled from 'styled-components'

const SocialAnchor = styled.a`
    width: 42px;
    height: 42px;
    border-radius: 999px;
    border: 1px solid ${(props) => props.theme.border};
    display: inline-flex;
    align-items: center;
    justify-content: center;
    background: rgba(255, 255, 255, 0.02);
    transition:
        transform 0.2s ease,
        border-color 0.2s ease,
        background 0.2s ease;

    svg {
        width: 20px;
        height: 20px;
        fill: ${(props) => props.theme.text};
        transition: fill 0.2s ease;
    }

    &:hover {
        transform: translateY(-2px);
        border-color: ${(props) => props.theme.secondaryText};
        background: ${(props) => props.theme.hoverBackground};

        svg {
            fill: ${(props) => props.theme.buttonText};
        }
    }
`

export type SocialLinkProps = {
    svg: ReactElement
    link: any
}

export default function SociaLink({
    svg,
    link,
}: SocialLinkProps): ReactElement {
    return (
        <SocialAnchor href={link} target="_blank" rel="noopener noreferrer">
            {svg}
        </SocialAnchor>
    )
}
